import React, { useState, useRef } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

function Map(props) {
  let initialCenter = props.center;
  if (!initialCenter) {
    initialCenter = { lat: 51.0438715, lng: -114.0713467 };
  }

  const [center, setCenter] = useState(initialCenter);
  const markerRef = useRef(null);

  const onMarkerDragEnd = () => {
    const markerPosition = markerRef.current.getPosition();
    const newCenter = {
      lat: markerPosition.lat(),
      lng: markerPosition.lng(),
    };
    setCenter(newCenter);
    props.onMarkerChanged(newCenter);
  };

  React.useEffect(() => {
    if (props.center) {
      setCenter(props.center);
    }
  }, [props.center]);

  return (
    <GoogleMap
      defaultZoom={8}
      center={center}
      zoom={13}
      options={{ streetViewControl: false }}
    >
      {props.isMarkerShown && (
        <Marker
          position={center}
          ref={markerRef}
          draggable={true}
          onMouseUp={onMarkerDragEnd}
        />
      )}
    </GoogleMap>
  );
}

export default withScriptjs(withGoogleMap(Map));
